let modalOverlay: HTMLDivElement | null = null;
let modalIframe: HTMLIFrameElement | null = null;
let closeButton: HTMLButtonElement | null = null;
let urlstring = '';
const IFRAME_CLOSE_MESSAGE = 'IZI_BNPL_CLOSE_IFRAME';

const shouldCloseFrameFromMessage = (data: unknown): boolean => {
  if (typeof data === 'string') {
    return data === IFRAME_CLOSE_MESSAGE;
  }

  if (typeof data !== 'object' || data === null) {
    return false;
  }

  const messageData = data as { type?: string; status?: string };
  return (
    messageData.type === IFRAME_CLOSE_MESSAGE &&
    messageData.status?.toLowerCase() === 'success'
  );
};

const isMessageFromCurrentFrameOrigin = (origin: string): boolean => {
  if (!urlstring) return false;

  try {
    const frameOrigin = new URL(urlstring).origin;
    return frameOrigin === origin;
  } catch {
    return false;
  }
};

const onFrameMessage = (event: MessageEvent) => {
  if (!modalOverlay || modalOverlay.style.display !== 'flex') return;
  if (!isMessageFromCurrentFrameOrigin(event.origin)) return;
  if (!shouldCloseFrameFromMessage(event.data)) return;

  closeFrame();
};

function createModal() {
  if (modalOverlay) return; // Already created

  // Create overlay
  modalOverlay = document.createElement('div');
  modalOverlay.id = 'iframe-modal-overlay';
  modalOverlay.style.cssText = `
    display: none;
    position: fixed;
    top: 0; left: 0;
    width: 100%; height: 100%;
    background: rgba(0,0,0,0.5);
    z-index: 10000;
    justify-content: center;
    align-items: center;
  `;

  // Create content container
  const modalContent = document.createElement('div');
  modalContent.style.cssText = `
    position: relative;
    width: 80%;
    height: 80%;
    background: white;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 10px rgba(0,0,0,0.3);
  `;

  // Create close button
  closeButton = document.createElement('button');
  closeButton.innerText = 'x';
  closeButton.style.cssText = `
    position: absolute;
    top: 10px;
    width:30px;
    height:30px;
    padding:0px !important;
    border-radius:5px;
    color:'#000000 !important';
    right: 15px;
    border: none;
    font-size: 20px !important;
    cursor: pointer;
    z-index: 10001;
    outline: none;
  `;
  closeButton.addEventListener('click', closeFrame);

  // Create iframe
  modalIframe = document.createElement('iframe');
  modalIframe.style.cssText = `
    width: 100%;
    height: 100%;
    border: none;
  `;
  // Add permissions as needed
  // Add the `allow` attribute to permit camera and microphone access
  modalIframe.setAttribute('allow', 'camera; microphone');

  modalContent.appendChild(closeButton);
  modalContent.appendChild(modalIframe);

  modalOverlay.appendChild(modalContent);
  document.body.appendChild(modalOverlay);

  window.addEventListener('message', onFrameMessage);

  // Expose closeFrame globally so iframe content can call it
  (
    window as Window & typeof globalThis & { closeFrame: () => void }
  ).closeFrame = closeFrame;
}

function extractParams(url: string): Record<string, string | null> {
  const parsedUrl = new URL(url);
  const params: Record<string, string | null> = {};

  parsedUrl.searchParams.forEach((value, key) => {
    params[key] = value || null;
  });

  return params;
}

// export function openFrame(url: string) {
//   window.open(url, '_blank', 'noopener,noreferrer');
// }

export function openFrame(url: string) {
  createModal();
  urlstring = url;
  if (modalOverlay && modalIframe) {
    modalIframe.src = url;
    modalOverlay.style.display = 'flex';
  }
}

export function closeFrame() {
  if (modalOverlay && modalIframe) {
    const params = extractParams(urlstring);
    console.log(params['purchaseCode']);
    modalIframe.src = '';
    modalOverlay.style.display = 'none';
    urlstring = '';
  }
}

// Auto create modal on script load
createModal();
